import ApiService from '@/api/service/ApiService.js';
const uuidv1 = require('uuid/v1');
const querystring = require('querystring')
var OtpService = {
    sendOtp($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.url = 'sendOtp'
            if ($data) {
                $options.data = $data
            }
            $options.method = "post"
            ApiService.request($options)
                .then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
        });
    },
    verifyOtp($data) {
        return new Promise(function (resolve, reject) {

            var $options = {};
            $options.url = 'verifyOtp'
            if ($data) {
                $options.data = $data
            }
            $options.method = "post"
            ApiService.request($options)
                .then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })

        });
    },
};
export default OtpService;